import LocalizedLink from '@components/Localization/LocalizedLink'
import { Field } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type PrivacyPolicyFieldProps = {
  formId: string
}

export const PrivacyPolicyField: FC<PrivacyPolicyFieldProps> = ({ formId }) => {
  const { t } = useTranslation('forms')

  return (
    <Field
      id={`${formId}-newsletter-signup-checkbox`}
      name="newsletterSignup"
      label={
        <>
          {t('labels.acceptNewsletterAndConditions', { ns: 'forms' })}{' '}
          <LocalizedLink href={t('privacyPolicy', { ns: 'navigation' })}>
            <a href={t('privacyPolicy', { ns: 'navigation' })}>{t('moreInfo', { ns: 'other' })}</a>
          </LocalizedLink>
        </>
      }
      field="checkbox"
      gridColumn="span 12"
    />
  )
}
